import MapServiceModel          from '@/models/MapServiceModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import type { StatusReference } from '@models/map/planImport/PlanAnalysisModel';

@model.urnResource('plan_detection')
@doc.path('/plan_detections/{?id}')
export default class PlanDetectionModel extends MapServiceModel {
	@doc.json   declare planDetectionStatus: StatusReference | string;
	@doc.json   declare result: Record<string, unknown> | null;
	@doc.string declare errorMessage: string | null;
}
